import { useTranslations } from 'next-intl';
import { Container } from '..';
import { H2 } from './styleConstants';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './BGImageTextSection.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

export const BGImageTextSection = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  return (
    <section
      className={cx(styles.root, className)}
      style={{
        ['--bg-image' as string]: `url(${getCompressedAssetUrl(
          '/web_v2/backgrounds/responsive/particle-ring-air.png/w_1920',
        )})`,
        ['--bg-image-md' as string]: `url(${getCompressedAssetUrl(
          '/web_v2/backgrounds/particle-ring-air.png/w_2048',
        )})`,
      }}
    >
      <Container>
        <H2>{t('bGImageTextSection.h2.mightyLightAmazingly')}</H2>
      </Container>
    </section>
  );
};
